import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function LogoutDialog({ open, onClose }) {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('user');
    document.cookie = "auth_token=; path=/; domain=.e-beehive.local; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
    document.location.href = process.env.REACT_APP_WWW_URL;
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { borderRadius: 3, p: 1 } }}
    >
      <DialogTitle sx={{ fontWeight: 'bold' }}>Αποσύνδεση;</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Είστε σίγουροι ότι θέλετε να βγείτε από το λογαριασμό σας;
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ pb: 2, px: 2 }}>
        <Button
          onClick={onClose}
          sx={{ color: 'text.secondary' }}
        >
          Ακύρωση
        </Button>
        <Button
          onClick={handleLogout}
          variant="contained"
          color="error"
          autoFocus
          sx={{ }}
        >
          Έξοδος
        </Button>
      </DialogActions>
    </Dialog>
  );
}
